import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      value: null
    };
  },
  methods: {
    openTransactionDetail() {
      this.params.context.componentParent.openTransactionDetail(
        this.params.data.id
      );
    }
  },
  template: `
        <div class="flex flex-row">
            <span class="no-underline hover:underline cursor-pointer mr-4" v-on:click="openTransactionDetail">
                {{this.params.value}}
            </span>
        </div>
    `
});
